import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class MapService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  public getHeatMapP2PDenoxData(filterTimeSeconds: String): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/p2pGoDenoxHeatMap`,
      filterTimeSeconds,
      { withCredentials: true }
    );
  }
  public getMapTowerLoRaWANData(filterTimeSeconds: String): Observable<any> {
    return this.http.post<any>(
      `${this.apiServerUrl}/api/v1/towerLoRaWANMap`,
      filterTimeSeconds,
      { withCredentials: true }
    );
  }
}
